import * as Bouncer from 'formbouncerjs';
export const messagesOverride = {
    checkCountry: larry.strings.errors.checkCountry,
    missingValue: {
        checkbox: larry.strings.errors.required,
        radio: larry.strings.errors.select,
        select: larry.strings.errors.select,
        default: larry.strings.errors.default
    }
};
export var customCheck = {
    customValidations: {
        checkCountry: function (field) {
            console.log('Checking country');
            var isCountry = field.hasAttribute('data-country-check');
            if (isCountry && field.value == 'notvalid')
                return true;
            return false;
        }
    },
    messages: messagesOverride
};
export var formValidate = new Bouncer('.wm-form__signup', customCheck);
export var validateChecklist = new Bouncer('.wm-form__checklistSignup', customCheck);
export var validateTipslist = new Bouncer('#wm-form__tipsListSignup', customCheck);
export var validateQuestionlist = new Bouncer('#wm-form__questionListSignup', customCheck);
export var validateNewsSignup = new Bouncer('.wm-form__newsSignup', customCheck);
var validateVerifyEmail = new Bouncer('.wm-form__verify', {
    messages: messagesOverride
});
window.validateChecklist = validateChecklist;
